import { distributionAccountMutations } from "./accounts/mutations";
import { orderMutations } from "./orders/mutations";
import { importsMutations } from "./imports/mutations";
import { distributionSupplierMutations } from "./suppliers/mutations";
import { distributionStatementsMutations } from "./statement/mutations";
import { shopsDistributionMutations } from "./shops/mutations";
import { shop_groupsDistributionMutations } from "./shop_groups/mutations";
import { DistributionModulePluginStore } from "./plugin-store";
import { distributionSupplierOrderMutations } from "./supplier_orders/mutations";
import { distributionReleaseReportMutations } from "./release_report/mutations";
export const mutations = {
  ...importsMutations,
  ...distributionAccountMutations,
  ...orderMutations,
  ...distributionSupplierMutations,
  ...distributionStatementsMutations,
  ...shopsDistributionMutations,
  ...shop_groupsDistributionMutations,
  ...distributionSupplierOrderMutations,
  ...distributionReleaseReportMutations,
  ...DistributionModulePluginStore.mutations,
};
